import {
  combineReducers
} from 'redux'
import {
  createReducer
} from 'helpers/ReducerUtil'
import {
  UPDATE_INPUT_VALUE,
  CLEAR_PRODUCT_LIST,
  TOGGLE_POPUP,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  UPDATE_PRODUCT_SKUS,
  POST_FORM_START,
  POST_FORM_SUCCESS,
  POST_FORM_ERROR,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
} from './constants'

const updateSegmentList = (prev, { segments }) => segments.map(seg => ({ value: seg, label: seg }))
const updateLineList = (prev, { lines }) => lines.map(line => ({ value: line, label: line }))
const updateProductSkus = (prev, { products }) => products.map(product => ({ 
  value: `${product.sku} (${product.family}, ${product.platform})`, 
  label: `${product.sku} (${product.family}, ${product.platform})`,
  attrs: {
    sku: product.sku,
    family: product.family,
    platform: product.platform
  }
}))
const updateInputValue = (state, action) => action.value
const toggleFlag = (value) => !value
const clearInputValue = () => ''

const inputValueReducer = createReducer('', {
  [UPDATE_INPUT_VALUE]: updateInputValue,
  [CLEAR_PRODUCT_LIST]: clearInputValue,
})

const togglePopupReducer = createReducer('', {
  [TOGGLE_POPUP]: toggleFlag,
})

const segmentReducer = createReducer('', {
  [UPDATE_SEGMENT_LIST]: updateSegmentList,
})

const lineReducer = createReducer('', {
  [UPDATE_LINE_LIST]: updateLineList,
})

const skusReducer = createReducer('', {
  [UPDATE_PRODUCT_SKUS]: updateProductSkus,
})

const createProductReducer = createReducer('', {
  [POST_FORM_START]: toggleFlag,
  [POST_FORM_SUCCESS]: toggleFlag,
  [POST_FORM_ERROR]: toggleFlag
})

const loadingSkuListReducer = createReducer('', {
  [FETCH_PRODUCT_SKUS_START]: toggleFlag,
  [FETCH_PRODUCT_SKUS_SUCCESS]: toggleFlag,
  [FETCH_PRODUCT_SKUS_ERROR]: toggleFlag
})

export const uiStateReducer = combineReducers({
  inputValue: inputValueReducer,
  activeAddDialog: togglePopupReducer,
  creatingProduct: createProductReducer,
  loadingSkuList: loadingSkuListReducer,
  segmentSources: segmentReducer,
  lineSources: lineReducer,
  productSkuSources: skusReducer,
})